import { View, Text } from "react-native";
import React from "react";
import translate from "../../functions/translate";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import MyButton from "./MyButton";
import { useDispatch } from "react-redux";
import { setLoginModal } from "../../redux/modal/modalAction";
import MyText from "./MyText";
import { darkGreen, orange, textSecondary } from "../../colors";
import LoginModal from "../modals/LoginModal";
import { useNavigation } from "@react-navigation/native";

export default function LoginFirst({
  size,
  showLoginButton,
  showSignupButton,
}) {
  const dispatch = useDispatch();
  const navigation = useNavigation();

  return (
    <View
      style={{
        width: "100%",
        height: "100%",
        alignItems: "center",
        marginTop: 20,
      }}
    >
      <MaterialCommunityIcons
        name="login-variant"
        size={size * 2}
        color="#ddd"
      />
      <MyText
        style={{ fontSize: size / 1.5, color: "#777", marginVertical: 10 }}
      >
        {translate("please login first")}
      </MyText>
      {showLoginButton && (
        <MyButton
          style={{ marginVertical: 20, width: "90%" }}
          text={translate("login")}
          onPress={() => dispatch(setLoginModal(true))}
        />
      )}
      {showSignupButton && (
        <MyButton
          style={{
            marginVertical: 5,
            width: "90%",
            backgroundColor: orange,
          }}
          text={translate("signup")}
          onPress={() => navigation.navigate("UserRegister")}
        />
      )}
    </View>
  );
}
LoginFirst.defaultProps = {
  showLoginButton: true,
  showSignupButton: true,
  size: 30,
};
